import { createSlice } from "@reduxjs/toolkit"

// types
import { MenuProps } from "types/menu"

// initial state
const initialState: MenuProps = {
    openItem: ["dashboard"],
    openComponent: "buttons",
    selectedID: null,
    drawerOpen: false,
    componentDrawerOpen: true,
    menu: {},
    error: null,
}

// ==============================|| SLICE - MENU ||============================== //

const menu = createSlice({
    name: "menu",
    initialState,
    reducers: {
        activeItem(state, action) {
            state.openItem = action.payload.openItem
        },

        activeID(state, action) {
            state.selectedID = action.payload
        },

        activeComponent(state, action) {
            state.openComponent = action.payload.openComponent
        },

        openDrawer(state, action) {
            state.drawerOpen = action.payload
        },

        hasError(state, action) {
            state.error = action.payload
        },
    },
})

export default menu.reducer

export const { activeItem, activeComponent, openDrawer, activeID } = menu.actions
